<div class="tab-section">

    <div class="dropdown-select">
        <div class="d-flex">
            <p class="textBlueBold mr-10">Division : </p>
        <p-dropdown 
        id="divisionDropdown"
            [options]="dropDownData" 
            [(ngModel)]="selectedDivision" 
            optionLabel="label"
            optionValue="value"
            styleClass="ml-10 ht-35"
            [autoDisplayFirst]="true"
            (onChange)="onDivisionChange()">
        </p-dropdown>
    </div>
    </div>
    <div class="my-tlrs-container mt-10">


        <p-table [value]="filterdInstalledData" [scrollable]="true" id="StyleTable" scrollHeight="400px">
            <ng-template pTemplate="header">
                <tr>
                    <th>Division</th>
                    <th>Section</th>
                    <th>User Id</th>
                    <th>TLR#</th>
                    <th>TLR Status</th>
                    <th></th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td >{{row.division_name}}</td>
                    <td >{{row.section_name}}</td>
                    <td >{{row.engineering_cai}}</td>
                    <td [ngClass]="row.cssClass" >{{row.tag_number}}</td>
                    <td [ngClass]="row.cssClass">{{row.status}}</td>
                    <td><a (click)="details(row)" class="link-underline">Details</a></td>
                    <td><a (click)="editTle(row)" class="link-underline">Reassign</a></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4" class="text-center">No TLRs assigned to you</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>